export default "__VITE_ASSET__e654972b__"